module.exports = __webpack_public_path__ + "img/14.e62d5050.jpg";